"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));
var _coreListGroup = _interopRequireDefault(require("@legacy-vfuk/core-list-group"));
var Styled = _interopRequireWildcard(require("./styles/StateText.style"));
var _constants = require("../../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StateText = function StateText(_ref) {
  var state = _ref.state,
    stateText = _ref.stateText,
    formElementId = _ref.formElementId,
    validateOn = _ref.validateOn,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var stateTextId = "".concat(formElementId, "-").concat(_constants.STATE_TEXT);
  var getAriaLive = function getAriaLive() {
    if (!validateOn) return 'off';
    if (state === 'error') return 'assertive';
    return 'polite';
  };
  var isMultipleStateText = Array.isArray(stateText) && (stateText === null || stateText === void 0 ? void 0 : stateText.length) > 1;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.StateTextContainer, {
    id: stateTextId,
    multipleStateText: isMultipleStateText,
    state: state,
    "aria-live": getAriaLive(),
    "aria-atomic": true,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: state,
    group: "state",
    size: 1,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'icon')
  }), isMultipleStateText ? /*#__PURE__*/_react["default"].createElement(_coreListGroup["default"], {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'multiple-state-text')
  }, stateText.map(function (text, key) {
    return /*#__PURE__*/_react["default"].createElement(Styled.StateText, {
      state: state,
      key: key,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "state-text-".concat(key))
    }, text);
  })) : stateText));
};
StateText.displayName = "StateText";
var _default = StateText;
exports["default"] = _default;
//# sourceMappingURL=StateText.js.map